import { render, staticRenderFns } from "./SurveysSubmenu.vue?vue&type=template&id=43687e2f"
import script from "./SurveysSubmenu.vue?vue&type=script&lang=js"
export * from "./SurveysSubmenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports